import { ButtonHTMLAttributes, FC } from "react";
import styles from "./ButtonPageLayout.module.scss";

interface ButtonPageLayoutProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const ButtonPageLayout: FC<ButtonPageLayoutProps> = ({
  children,
  ...rest
}) => {
  return (
    <button className={styles.button} {...rest}>
      {children}
    </button>
  );
};
